import {Component, Inject, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {WORKFLOW_DATA_SERVICE_TOKEN} from '../shared/services/workflow-data.service';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.css']
})
export class EditComponent implements OnInit {

  constructor(private route: ActivatedRoute, @Inject(WORKFLOW_DATA_SERVICE_TOKEN) private workflowDataService) {
  }

  ngOnInit() {
    if (!this.route || !this.route.params) {
      return;
    }

    this.route.params.subscribe(p => {
      let travelCreditId = +p['id'];
      if (travelCreditId > 0) {
        this.workflowDataService.initializeTravelCredit(travelCreditId);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/edit/edit.component.ts